var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseForm',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_vm._v("Заполните дополнительные данные")]),_c('Solutions',{staticClass:"pl-8"})],1)]},proxy:true},{key:"buttons",fn:function(){return [_c('Button',{staticStyle:{"float":"right"},attrs:{"loading":_vm.isLoading},on:{"click":_vm.next}},[_vm._v(" Отправить ")])]},proxy:true}])},[_c('v-form',{ref:"form"},[_c('v-row',_vm._l(([
                    'maritalStatus',
                    'childsCount',
                    'homePhone',
                    'additionalPhone',
                    'education',
                    'employmentType' ]),function(name){return _c('Field',{key:name,attrs:{"anketaName":name}})}),1)],1),_c('v-form',[_c('v-row',_vm._l(([
                    'inn',
                    'position',
                    'workPhone' ]),function(name){return _c('Field',{key:name,attrs:{"anketaName":name}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }